module.exports = __webpack_public_path__ + "media/images/top/green_remove-97ec4bac1824f8b97345aebe49c52c3f.png";